import { useAuthContext } from "@/components/AuthProvider";
import type { AuthUser } from "@/types/auth";

/**
 * Returns the authenticated user or null if not authenticated.
 * Replaces the repeated pattern:
 *   if (authState.status !== "authenticated") return null;
 *   const { centerOwnerUid, centerId, instructorId } = authState.user.activeMembership;
 */
export function useAuthenticatedUser(): AuthUser | null {
  const { authState } = useAuthContext();
  if (authState.status !== "authenticated") return null;
  return authState.user;
}
